module.exports = __webpack_public_path__ + "img/flag.d59462ee.jpg";